<template>
  <LegalSiteArticle :page="dmcaPage" nav-page="dmca" />
</template>

<script>
import LegalSiteArticle from '@/components/LegalSiteArticle.vue'
import { dmcaPage } from '@/data/sitePages'

export default {
  components: { LegalSiteArticle },
  data() {
    return { dmcaPage }
  },
}
</script>
